(function () {
  document.addEventListener('click', (e) => {
    if (e.target.classList.contains('shopping-bag-d5')) {
      if (!e.target.classList.contains('active')) {
        e.target.classList.add('active');
        fetch('/cart/update.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({
            attributes: {
              'Shopping Bag': "Yes"
            }
          })
        });
      } else {
        e.target.classList.remove('active');
        fetch('/cart/update.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({
            attributes: {
              'Shopping Bag': ''
            }
          })
        });
      }
    }
    if (e.target.classList.contains('radio-button-d5')) {
      e.preventDefault();
      e.target.closest('.popup-content-d5').querySelectorAll('.message-input-d5').forEach(i => i.classList.remove('active'));
      e.target.closest('.message-input-d5').classList.add('active');
    }
    if (e.target.classList.contains('remove-the-message')) {
      e.preventDefault();
      e.target.closest('.message-input-d5').querySelector('.print-message-textarea-d5').value = '';
    }
    if (e.target.classList.contains('gift-message-save-d5')) {
      const textarea = e.target.closest('.popup-content-d5').querySelector('.print-message-textarea-d5');
      const inputA = e.target.closest('.popup-content-d5').querySelector('.print-the-message-input-d5.active');
      if (textarea && inputA) {
        const valueT = textarea.value
        fetch('/cart/update.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({
            attributes: {
              'Print Message': valueT
            }
          })
        });

        document.querySelectorAll('.print-message-textarea-d5').forEach(i => {
          i.value = valueT;
          i.innerHTML = valueT;
        });

      } else {
        document.querySelectorAll('.print-message-textarea-d5').forEach(i => {
          i.value = '';
          i.innerHTML = '';
        });
        fetch('/cart/update.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({
            attributes: {
              'Print Message': ''
            } 
          })
        });

      }
      setTimeout(() => {
        document.querySelector('.acc__close').click();
      }, 500);
    }
  })
})()